import { render, staticRenderFns } from "./api-key-form.vue?vue&type=template&id=65200601"
import script from "./api-key-form.vue?vue&type=script&lang=js"
export * from "./api-key-form.vue?vue&type=script&lang=js"
import style0 from "./api-key-form.vue?vue&type=style&index=0&id=65200601&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports